import React from 'react';
import MainLayout from '../components/MainLayout';
import RobertImage from '../assets/robert.png'
import MaartenImage from '../assets/maarten.png'
import IliasImage from '../assets/ilias.png'
import TuanImage from '../assets/tuan.jpg'

const TeamPage = () => {
  return (
    <MainLayout>
      <div className="team-page">
        <div className="title">
          WHO is WHO in the WASP Project
        </div>
        <div>
          <div className="info-section-wrapper">
            <div className="info-section">
              <div className="name-bio">
                <div className="name">
                  Robert Malina
                </div>
                <p className="bio">
                  Robert is Full Professor in Environmental Economics and Director of CMK. He worked previously at Muenster University in Germany as a Lecturer in Economics and at the Massachusetts Institute of Technology as Associate Director of the Laboratory for Aviation and the Environment. Robert brings to the WASP project his expertise in non-market valuation, more specifically on the value of “nature”.
                </p>
              </div>
              <div className="image">
                <img src={RobertImage} alt="" />
              </div>
            </div>
          </div>
          <div className="info-section-wrapper">
            <div className="info-section">
              <div className="image">
                <img src={MaartenImage} alt="" />
              </div>
              <div className="name-bio">
                <div className="name">
                  Maarten Vanhove
                </div>
                <p className="bio">
                  Maarten is Assistant Professor in Biology within the Research Group Zoology of CMK. He previously worked the Royal Museum for Central Africa (Belgium), the Hellenic Centre for Marine Research (Greece), Masaryk University (Czech Republic), the Royal Belgian Institute of Natural Sciences, and the Finnish Museum of Natural History within the University of Helsinki. Maarten brings to the WASP project not only his experience as a biodiversity scientist, but also his international network in conservation and development cooperation.
                </p>
              </div>
            </div>
          </div>
          <div className="info-section-wrapper">
            <div className="info-section">
              <div className="name-bio">
                <div className="name">
                  Tuan Nguyen
                </div>
                <p className="bio">
                  Tuan completed his Master's degree in Economics & Ecology, an interdisciplinary program co-organized by Toulouse School of Economics and Paul Sabatier University (France). He embarks on the WASP project as a new PhD student and brings to the project his enthusiasm and multi-disciplinary view combining recent progress in environmental economics, ecology and biodiversity conservation.
                </p>
              </div>
              <div className="image">
                <img src={TuanImage} alt="" />
              </div>
            </div>
          </div>
          <div className="info-section-wrapper">
            <div className="info-section">
              <div className="name-bio">
                <div className="name">
                  Ilias Mokas
                </div>
                <p className="bio">
                  Ilias Mokas is specializing in the data-driven mathematical modeling of human choices. With expertise in discrete choice analysis and machine learning, he focuses on the estimation and interpretation of such models across different disciplines, although most of his applied work has been conducted in the field of environmental economics. He previously worked at the European Commission’s Joint Research Center and Copenhagen Business School.
                </p>
              </div>
              <div className="image">
                <img src={IliasImage} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default TeamPage;